import { Container, Typography, Box, Link } from "@mui/material";

const TermsOfService = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        RocketOffer.com – Terms of Service
      </Typography>
      <Typography variant="body1" paragraph>
        Effective Date: June 2, 2025
      </Typography>

      <Box sx={{ my: 2 }}>
        <Typography variant="h6">1. Eligibility</Typography>
        <Typography variant="body1" paragraph>
          You must be at least 18 years old and capable of entering into a legally binding agreement to use RocketOffer.com. By using the Site, you represent and warrant that you meet these requirements.
        </Typography>
      </Box>

      <Box sx={{ my: 2 }}>
        <Typography variant="h6">2. Services Provided</Typography>
        <Typography variant="body1" paragraph>
          RocketOffer.com offers services including:
        </Typography>
        <ul>
          <li>Cash offers for homes</li>
          <li>Nontraditional home renovation financing</li>
          <li>Contractor recommendations and project management</li>
          <li>Staging, photography, and marketing services</li>
          <li>Access to home listings and investment opportunities</li>
          <li>Agent collaboration tools</li>
        </ul>
        <Typography variant="body1" paragraph>
          We may update, modify, or remove services at any time without notice.
        </Typography>
      </Box>

      <Box sx={{ my: 2 }}>
        <Typography variant="h6">3. User Responsibilities</Typography>
        <Typography variant="body1" paragraph>
          You agree to:
        </Typography>
        <ul>
          <li>Provide accurate and complete information during registration or service engagement</li>
          <li>Keep your account login credentials secure</li>
          <li>Use RocketOffer.com only for lawful and authorized purposes</li>
          <li>Refrain from misusing the platform, scraping data, or interfering with service operations</li>
        </ul>
      </Box>

      <Box sx={{ my: 2 }}>
        <Typography variant="h6">4. No Real Estate Brokerage</Typography>
        <Typography variant="body1" paragraph>
          RocketOffer.com is not a licensed real estate broker. We provide tools, offers, and services to support transactions, but we do not represent either party in a real estate transaction unless explicitly stated in writing.
        </Typography>
      </Box>

      <Box sx={{ my: 2 }}>
        <Typography variant="h6">5. Financing and Payments</Typography>
        <ul>
          <li>Terms will be governed by a separate written agreement</li>
          <li>Payment is typically due at closing or sale of the property</li>
          <li>RocketOffer.com reserves the right to place a lien or enforce collection, as permitted by law</li>
        </ul>
      </Box>

      <Box sx={{ my: 2 }}>
        <Typography variant="h6">6. User Content</Typography>
        <ul>
          <li>You grant RocketOffer.com a non-exclusive, royalty-free license to use, display, and reproduce your content for service delivery</li>
          <li>You confirm that you own or have rights to all content you provide</li>
        </ul>
      </Box>

      <Box sx={{ my: 2 }}>
        <Typography variant="h6">7. Privacy</Typography>
        <Typography variant="body1" paragraph>
          Your use of RocketOffer.com is also subject to our{" "}
          <Link href="/privacy-policy" underline="hover">
            Privacy Policy
          </Link>
          , which explains how we collect, use, and protect your information.
        </Typography>
      </Box>

      <Box sx={{ my: 2 }}>
        <Typography variant="h6">8. Disclaimers</Typography>
        <Typography variant="body1" paragraph>
          RocketOffer.com provides services “as is” without warranties of any kind, express or implied. We do not guarantee results, market performance, or the accuracy of property valuations or offers. Use of the Site and services is at your own risk.
        </Typography>
      </Box>

      <Box sx={{ my: 2 }}>
        <Typography variant="h6">9. Limitation of Liability</Typography>
        <Typography variant="body1" paragraph>
          To the maximum extent permitted by law, RocketOffer.com shall not be liable for indirect, incidental, special, or consequential damages, or for loss of profits or revenue arising from your use of the Site or services.
        </Typography>
      </Box>

      <Box sx={{ my: 2 }}>
        <Typography variant="h6">10. Termination</Typography>
        <Typography variant="body1" paragraph>
          We reserve the right to suspend or terminate your access to RocketOffer.com at any time, with or without cause or notice. You may also terminate your use at any time.
        </Typography>
      </Box>

      <Box sx={{ my: 2 }}>
        <Typography variant="h6">11. Governing Law</Typography>
        <Typography variant="body1" paragraph>
          This Agreement is governed by the laws of the State of Michigan, without regard to conflict of law principles. Any disputes must be resolved in state or federal courts located in Michigan.
        </Typography>
      </Box>

      <Box sx={{ my: 2 }}>
        <Typography variant="h6">12. Changes to the Agreement</Typography>
        <Typography variant="body1" paragraph>
          We may update this Agreement from time to time. Continued use of RocketOffer.com after changes means you accept the updated terms.
        </Typography>
      </Box>

      <Box sx={{ my: 2 }}>
        <Typography variant="h6">13. No Guarantee of Results</Typography>
        <Typography variant="body1" paragraph>
          RocketOffer.com makes no representations or guarantees regarding the outcome of any real estate transaction, renovation project, or marketing campaign conducted through or in connection with our services. While we aim to provide effective tools, expert guidance, and access to reputable service providers, we do not guarantee that:
        </Typography>
        <ul>
          <li>A property will sell within a specific timeframe</li>
          <li>You will receive a particular offer price or profit margin</li>
          <li>Renovations will increase property value by a specific amount</li>
          <li>Buyers or investors will complete a transaction</li>
          <li>Any financing, sale, or service outcome will meet your expectations</li>
        </ul>
        <Typography variant="body1" paragraph>
          Real estate markets are inherently unpredictable and affected by a wide range of external factors outside our control. By using RocketOffer.com, you acknowledge and accept these risks.
        </Typography>
      </Box>

      <Box sx={{ my: 2 }}>
        <Typography variant="h6">14. Contact</Typography>
        <Typography variant="body1" paragraph>
          For questions or concerns about this User Agreement, please contact us at:
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          RocketOffer.com Inc. <br />
          28588 Northwestern Hwy<br />
          Suite 100<br />
          Southfield, MI 48034<br />
          Email:{" "}
          <Link href="mailto:support@rocketoffer.com" underline="hover">
            support@rocketoffer.com
          </Link>
          <br />
          Phone: (866) 826-5205
        </Typography>
      </Box>

      <Typography variant="body2" sx={{ mt: 4, fontStyle: 'italic' }}>
        This User Agreement was last updated on June 2, 2025.
      </Typography>
    </Container>
  );
};

export default TermsOfService;
